import benefit1 from './images/vip-benefit1-bg-big.png';
import benefit2 from './images/vip-benefit2-bg-big.png';
import benefit3 from './images/vip-benefit3-bg-big.png';
import benefit4 from './images/vip-benefit4-bg-big.png';

import benefitLong1 from './images/vip-benefit-bg-vip1.png';
import benefitLong2 from './images/vip-benefit-bg-vip2.png';
import benefitLong3 from './images/vip-benefit-bg-vip3.png';
import benefitLong4 from './images/vip-benefit-bg-vip4.png';
import benefitLong5 from './images/vip-benefit-bg-vip5.png';
import orangeEffectJson from './lottery/vip-level/orange/data.json';
import blueEffectJson from './lottery/vip-level/blue/data.json';
import yellowEffectJson from './lottery/vip-level/yellow/data.json';
import greenEffectJson from './lottery/vip-level/green/data.json';


export const benefitBgMap = {
  '1': benefit1,
  '2': benefit2,
  '3': benefit3,
  '4': benefit4,
};

export const benefitLongBgMap = {
  '1': benefitLong1,
  '2': benefitLong2,
  '3': benefitLong3,
  '4': benefitLong4,
  '5': benefitLong5,
};

/**
 * 
 * @param vip头图lottery动画
 * @returns 
 */
export function getVipLotteryJson(level: number) {
  if (level < 6) {
    return greenEffectJson;
  } else if (level <= 10) {
    return yellowEffectJson;
  } else if (level < 16) {
    return blueEffectJson;
  } else {
    return orangeEffectJson;
  }
}